var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32394 14.2696C1.77465 14.2978 2.28169 14.2696 3.01408 14.185C4.22535 14.044 5.38028 13.5364 6.25352 12.6903C7.26761 11.7597 8 10.3779 8.28169 8.57303C7.35211 9.61646 6.11268 10.2369 4.56338 10.2369C1.77465 10.2651 0 8.15002 0 5.49915C0 2.59447 2.14084 0 5.29577 0C8.4507 0 10.4225 2.56627 10.4225 6.54258C10.4225 9.95487 9.2676 12.3237 7.74648 13.8184C6.56338 14.9746 4.92958 15.7078 3.23944 15.877C2.50704 15.9898 1.80282 16.018 1.32394 15.9898V14.2696ZM2.08451 5.38634C2.08451 7.304 3.23944 8.68583 5.07042 8.68583C6.4507 8.68583 7.57746 7.98081 8.11268 7.05019C8.22535 6.85278 8.30986 6.62718 8.30986 6.28877C8.30986 3.6379 7.32394 1.63564 5.12676 1.63564C3.32394 1.60744 2.08451 3.18669 2.08451 5.38634Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.7712da004af4749680285560b780287e.svg";
export { ForwardRef as ReactComponent };